import moment from 'moment'

export default function formatDate(value){
  if (value) {
      let d = moment.utc(value)
      return moment(d.toDate()).format('MM/DD/YYYY hh:mm A')
  }
}



// WEBPACK FOOTER //
// ./src/filters/DateFilter.js